import { createContext, useContext } from "react";

/** As paletas do kit: `light` (cores do design system `ds-*`, em todas as telas) e `dark`. */
export type HermesTheme = "light" | "dark";

/**
 * O tema da tela em volta. Painéis, diálogos e avisos vão para um portal no `body`, fora da raiz
 * `.hermes` da tela, e religam os tokens por conta própria: sem isto cada um teria de receber o
 * tema por prop e, esquecido, voltaria para o claro do backoffice.
 */
export const HermesThemeContext = createContext<HermesTheme>("light");

export const useHermesTheme = (): HermesTheme => useContext(HermesThemeContext);
